"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[976],{

/***/ 7417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.54 3.066a.5.5 0 0 1 .92 0l1.586 3.684a.5.5 0 0 0 .413.3l3.993.37a.5.5 0 0 1 .284.874l-3.013 2.647a.5.5 0 0 0-.158.486l.882 3.912a.5.5 0 0 1-.743.54l-3.449-2.047a.5.5 0 0 0-.51 0l-3.449 2.047a.5.5 0 0 1-.743-.54l.882-3.912a.5.5 0 0 0-.158-.486L3.264 8.294a.5.5 0 0 1 .284-.873l3.993-.37a.5.5 0 0 0 .413-.3l1.587-3.685Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgStarFilled);

/***/ }),

/***/ 7942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Rating; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./public/icons/xsmall/Star-filled.svg
var Star_filled = __webpack_require__(7417);
;// CONCATENATED MODULE: ./src/components/elements/Rating/Rating.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: var(--color-testimonials-filled-star);\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: var(--color-testimonials-empty-star);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-testimonials-filled-star);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stop-color: var(--color-testimonials-filled-star);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  stop-color: var(--color-testimonials-empty-star);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledStar = (0,styled_components_browser_esm/* default */.ZP)(Star_filled/* default */.Z).withConfig({
    componentId: "sc-15a5af28-0"
})(_templateObject2(), function(param) {
    var $filled = param.$filled;
    return $filled ? (0,styled_components_browser_esm/* css */.iv)(_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var StyledFluidStar = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-15a5af28-1"
})(_templateObject3());
var StyledStarStopFill = styled_components_browser_esm/* default.stop.withConfig */.ZP.stop.withConfig({
    componentId: "sc-15a5af28-2"
})(_templateObject4());
var StyledStarStopBackground = styled_components_browser_esm/* default.stop.withConfig */.ZP.stop.withConfig({
    componentId: "sc-15a5af28-3"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/elements/Rating/Rating.tsx



var FluidStar = function(param) {
    var fillPercentage = param.fillPercentage, index = param.index;
    var id = "rating-star-".concat(index);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFluidStar, {
        fill: "none",
        viewBox: "0 0 20 20",
        width: "20",
        height: "20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarStopFill, {
                            offset: "0%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarStopFill, {
                            offset: "".concat(fillPercentage, "%")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarStopBackground, {
                            offset: "".concat(fillPercentage, "%")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarStopBackground, {
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#".concat(id, ")"),
                d: "M9.54 3.066a.5.5 0 0 1 .92 0l1.586 3.684a.5.5 0 0 0 .413.3l3.993.37a.5.5 0 0 1 .284.874l-3.013 2.647a.5.5 0 0 0-.158.486l.882 3.912a.5.5 0 0 1-.743.54l-3.449-2.047a.5.5 0 0 0-.51 0l-3.449 2.047a.5.5 0 0 1-.743-.54l.882-3.912a.5.5 0 0 0-.158-.486L3.264 8.294a.5.5 0 0 1 .284-.873l3.993-.37a.5.5 0 0 0 .413-.3l1.587-3.685Z"
            })
        ]
    });
};
var Rating = function(param) {
    var rating = param.rating, acceptDecimalPlaces = param.acceptDecimalPlaces;
    var starCount = 5;
    // limit rating to starCount
    var starRating = rating > starCount ? starCount : rating;
    // get half star value
    var halfStar = starRating * 10 % 10 / 10;
    if (acceptDecimalPlaces && halfStar) {
        // remove half star from rating
        var removedHalfStar = starRating - halfStar;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (0,_to_consumable_array/* default */.Z)(Array(starCount)).map(function(_element, index) {
                if (index === removedHalfStar) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FluidStar, {
                        index: index,
                        fillPercentage: halfStar * 100
                    }, index);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStar, {
                    width: "20",
                    height: "20",
                    $filled: Boolean(removedHalfStar > index)
                }, index);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,_to_consumable_array/* default */.Z)(Array(starCount)).map(function(_element, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStar, {
                width: "20",
                height: "20",
                $filled: Boolean(starRating > index)
            }, index);
        })
    });
};


/***/ }),

/***/ 2976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Testimonials": function() { return /* binding */ Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 105 modules
var swiper_react = __webpack_require__(56);
// EXTERNAL MODULE: ./src/components/elements/IconButton/IconButton.tsx
var IconButton = __webpack_require__(5556);
// EXTERNAL MODULE: ./src/components/utils/useIsSmallerThan.ts
var useIsSmallerThan = __webpack_require__(294);
// EXTERNAL MODULE: ./public/icons/small/Arrow-Thin-Left.svg
var Arrow_Thin_Left = __webpack_require__(3549);
// EXTERNAL MODULE: ./public/icons/small/Arrow-Thin-Right.svg
var Arrow_Thin_Right = __webpack_require__(9813);
// EXTERNAL MODULE: ./src/components/elements/Rating/Rating.tsx + 1 modules
var Rating = __webpack_require__(7942);
// EXTERNAL MODULE: ./src/components/elements/Copy/Copy.tsx
var Copy = __webpack_require__(8765);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/elements/Link/Link.tsx + 1 modules
var Link = __webpack_require__(874);
;// CONCATENATED MODULE: ./src/components/modules/Testimonial/Testimonial.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  grid-gap: var(--distance-static-xs);\n  align-items: center;\n\n  margin: 0 0 var(--distance-static-l) 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-testimonials-secondary);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-testimonials-main);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--distance-static-m);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: var(--distance-static-xs);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-testimonials-main);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  height: 32px;\n  width: 32px;\n  border-radius: 50%;\n  background-color: ",
        ";\n  color: var(--color-text-light);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StyledTestimonialWrapper = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-cfa178be-0"
})(_templateObject());
var StyledHeader = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-cfa178be-1"
})(_templateObject1());
var StyledLocation = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-cfa178be-2"
})(_templateObject2());
var StyledName = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-cfa178be-3"
})(_templateObject3());
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    componentId: "sc-cfa178be-4"
})(_templateObject4());
var StyledRateWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfa178be-5"
})(_templateObject5());
var StyledLinkShowMore = (0,styled_components_browser_esm/* default */.ZP)(Link/* Link */.r).withConfig({
    componentId: "sc-cfa178be-6"
})(_templateObject6());
var StyledBlockquote = styled_components_browser_esm/* default.blockquote.withConfig */.ZP.blockquote.withConfig({
    componentId: "sc-cfa178be-7"
})(_templateObject7());
var StyledDescription = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-cfa178be-8"
})(_templateObject8());
var StyledPlaceholder = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-cfa178be-9"
})(_templateObject9(), function(param) {
    var $index = param.$index;
    return "var(--color-testimonials-placeholder-".concat($index % 3, ")");
});

;// CONCATENATED MODULE: ./src/components/modules/Testimonial/Testimonial.tsx




var Thumbnail = function(param) {
    var image = param.image, name = param.name, index = param.index;
    if (image === null || image === void 0 ? void 0 : image.src) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
            src: image.src,
            alt: image.alt,
            width: 32,
            height: 32,
            layout: "fixed"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlaceholder, {
        text: name && name[0],
        size: "m",
        forwardedAs: "span",
        $index: index
    });
};
var Testimonial = function(param) {
    var image = param.image, name = param.name, location = param.location, rating = param.rating, description = param.description, showOriginalLabel = param.showOriginalLabel, showOriginalLink = param.showOriginalLink, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTestimonialWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, {
                        image: image,
                        name: name,
                        index: index
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("cite", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledName, {
                                text: name,
                                size: "m",
                                forwardedAs: "div"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocation, {
                                text: location,
                                size: "s",
                                forwardedAs: "div"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRateWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                        rating: rating
                    }),
                    showOriginalLabel && showOriginalLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkShowMore, {
                        rel: "noopener nofollow noreferrer",
                        target: "_blank",
                        href: showOriginalLink,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* Copy */.CK, {
                            size: "m",
                            text: showOriginalLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlockquote, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                    text: description,
                    size: "m"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/utils/mediaQueries.ts
var mediaQueries = __webpack_require__(5672);
// EXTERNAL MODULE: ./src/components/utils/gridCalc.ts
var gridCalc = __webpack_require__(3986);
// EXTERNAL MODULE: ./src/components/modules/Intro/Intro.tsx + 1 modules
var Intro = __webpack_require__(3172);
// EXTERNAL MODULE: ./src/components/modules/Wrapper/Wrapper.tsx + 1 modules
var Wrapper = __webpack_require__(8709);
;// CONCATENATED MODULE: ./src/components/modules/Testimonials/Testimonials.styled.ts

function Testimonials_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 0;\n"
    ]);
    Testimonials_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 0;\n"
    ]);
    Testimonials_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-dynamic-xl);\n  padding-top: var(--distance-dynamic-l);\n  background-color: var(--color-surface-light-subdued);\n"
    ]);
    Testimonials_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: var(--distance-static-5xl);\n"
    ]);
    Testimonials_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  gap: var(--distance-static-l);\n"
    ]);
    Testimonials_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: auto;\n  margin: 0 auto;\n\n  @media screen and (",
        ") {\n    width: ",
        ";\n  }\n"
    ]);
    Testimonials_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-static-xxl);\n\n  & > ul {\n    box-sizing: border-box;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    Testimonials_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Testimonials_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-testimonials-main);\n"
    ]);
    Testimonials_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var StyledIntro = (0,styled_components_browser_esm/* default */.ZP)(Intro/* Intro */.p).withConfig({
    componentId: "sc-d6f7551c-0"
})(Testimonials_styled_templateObject());
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-d6f7551c-1"
})(Testimonials_styled_templateObject1());
var StyledTestimonials = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-d6f7551c-2"
})(Testimonials_styled_templateObject2());
var StyledTestimonialsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6f7551c-3"
})(Testimonials_styled_templateObject3());
var StyledNavigationButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6f7551c-4"
})(Testimonials_styled_templateObject4());
var StyledSlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6f7551c-5"
})(Testimonials_styled_templateObject5(), mediaQueries/* tabletPortrait */.ZI, (0,gridCalc/* gridCalc */.T)(8));
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-d6f7551c-6"
})(Testimonials_styled_templateObject6());
var StyledOutOfCopy = (0,styled_components_browser_esm/* default */.ZP)(Copy/* Copy */.CK).withConfig({
    componentId: "sc-d6f7551c-7"
})(Testimonials_styled_templateObject7());

;// CONCATENATED MODULE: ./src/components/modules/Testimonials/Testimonials.tsx












var SwiperButton = function(param) {
    var direction = param.direction, label = param.label, swiperInstance = param.swiperInstance;
    var Buttons = {
        prev: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
            variant: "primaryAlt",
            label: label,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_Thin_Left/* default */.Z, {}),
            disabled: swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.isBeginning,
            onClick: function() {
                return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev();
            }
        }),
        next: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
            variant: "primaryAlt",
            label: label,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_Thin_Right/* default */.Z, {}),
            disabled: swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.isEnd,
            onClick: function() {
                return swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext();
            }
        })
    };
    return Buttons[direction];
};
var Testimonials = function(param) {
    var overline = param.overline, headline = param.headline, _outOfLabel = param.outOfLabel, outOfLabel = _outOfLabel === void 0 ? "" : _outOfLabel, _showOriginalLabel = param.showOriginalLabel, showOriginalLabel = _showOriginalLabel === void 0 ? "" : _showOriginalLabel, _testimonials = param.testimonials, testimonials = _testimonials === void 0 ? [] : _testimonials;
    var ref = (0,react.useState)(0), swiperIndex = ref[0], setSwiperIndex = ref[1];
    var ref1 = (0,react.useState)(), swiperInstance = ref1[0], setSwiperInstance = ref1[1];
    var isTablet = (0,useIsSmallerThan/* useIsSmallerThan */.s)("LAPTOP");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTestimonials, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            forwardedAs: "div",
            width: {
                laptop: "l",
                tabletLandscape: "m"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntro, {
                    headline: {
                        label: headline,
                        as: "h2",
                        size: "h3"
                    },
                    subtitle: overline,
                    nested: true
                }),
                isTablet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSlider, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
                            spaceBetween: 0,
                            slidesPerView: 1,
                            onSlideChange: function(swiper) {
                                setSwiperIndex(swiper.activeIndex);
                            },
                            tag: "div",
                            wrapperTag: "ul",
                            initialSlide: 0,
                            centeredSlides: true,
                            centeredSlidesBounds: true,
                            keyboard: true,
                            id: "testimonials-swiper",
                            onSwiper: function(swiper) {
                                return setSwiperInstance(swiper);
                            },
                            children: testimonials.map(function(_param, index) {
                                var id = _param.id, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "id"
                                ]);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    tag: "li",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                        index: index
                                    }))
                                }, id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavigationButton, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperButton, {
                                    label: "prev",
                                    direction: "prev",
                                    swiperIndex: swiperIndex,
                                    swiperInstance: swiperInstance
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOutOfCopy, {
                                    text: "".concat(swiperIndex + 1, " ").concat(outOfLabel, " ").concat(testimonials.length),
                                    size: "s"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperButton, {
                                    label: "next",
                                    direction: "next",
                                    swiperIndex: swiperIndex,
                                    swiperInstance: swiperInstance
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTestimonialsWrapper, {
                    children: testimonials.map(function(param, index) {
                        var id = param.id, name = param.name, location = param.location, rating = param.rating, description = param.description, image = param.image, showOriginalLink = param.showOriginalLink;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, {
                            name: name,
                            location: location,
                            rating: rating,
                            description: description,
                            image: image,
                            showOriginalLabel: showOriginalLabel,
                            showOriginalLink: showOriginalLink,
                            index: index
                        }, id);
                    })
                })
            ]
        })
    });
};


/***/ })

}]);